import Loadable from 'react-loadable';
import { PageLoadableComponent } from 'components/PageLoader/PageLoader';

export default Loadable({
  loader: () => import(/* webpackChunkName: "EditBlock" */ './EditBlock'),
  loading: PageLoadableComponent,
  delay: 200
});
